import { SCENARIO_ID } from '@/context';

// Set when a background site map is kicked off; the dock polls until ready, then opens the modal.
export const SITEMAP_PENDING_KEY = `__qc_sitemap_pending_${SCENARIO_ID}`;

// Set on over-limit upgrade so the dock reopens the modal after Stripe's redirect reload.
export const SITEMAP_RESUME_KEY = `__qc_sitemap_resume_${SCENARIO_ID}`;

// Set once a ready map's selection has been scraped, so the dock stops offering it.
export const SITEMAP_CONSUMED_KEY = `__qc_sitemap_consumed_${SCENARIO_ID}`;

// Timestamp (ms) holding the modal shut until the onboarding discount + confetti land.
// Session-scoped so a fresh tab doesn't inherit a stale deferral.
export const SITEMAP_CELEBRATE_UNTIL_KEY = `__qc_sitemap_celebrate_until_${SCENARIO_ID}`;

export const SITEMAP_CELEBRATE_MS = 2600;

// How long after kickoff the dock keeps polling an idle (404) map: covers the
// onboarding race where the flag lands before the backend creates the row.
const PENDING_FRESH_MS = 10 * 60_000;

export const setSiteMapPending = () =>
  localStorage.setItem(SITEMAP_PENDING_KEY, String(Date.now()));

export const isSiteMapPendingFresh = (): boolean => {
  const raw = localStorage.getItem(SITEMAP_PENDING_KEY);
  if (raw == null) return false;
  const startedAt = Number(raw);
  return Number.isFinite(startedAt) && Date.now() - startedAt < PENDING_FRESH_MS;
};

export const clearSiteMapFlags = () => {
  localStorage.removeItem(SITEMAP_PENDING_KEY);
  localStorage.removeItem(SITEMAP_RESUME_KEY);
};

// Wipe every site-map flag (incl. consumed marker + deferral) on outright discard.
export const forgetSiteMap = () => {
  clearSiteMapFlags();
  localStorage.removeItem(SITEMAP_CONSUMED_KEY);
  sessionStorage.removeItem(SITEMAP_CELEBRATE_UNTIL_KEY);
};

// Hold the review modal shut for `SITEMAP_CELEBRATE_MS` from now.
export const deferSiteMapModal = () => {
  sessionStorage.setItem(SITEMAP_CELEBRATE_UNTIL_KEY, String(Date.now() + SITEMAP_CELEBRATE_MS));
};

// Remaining defer time in ms (0 once the celebration window has elapsed).
export const siteMapDeferRemainingMs = (): number => {
  const until = Number(sessionStorage.getItem(SITEMAP_CELEBRATE_UNTIL_KEY) ?? 0);
  return Math.max(0, until - Date.now());
};

export const clearSiteMapDefer = () => sessionStorage.removeItem(SITEMAP_CELEBRATE_UNTIL_KEY);
